export default __webpack_public_path__ + "static/media/last_disabled.176809d8.svg";